<!--Skip to main content.-->
<app-skip-navigation></app-skip-navigation>
<!--The content below is only a placeholder and can be replaced.-->
<header role="banner" >
	<app-header *ngIf="!headerFooterHidden"></app-header>
</header>
<main role="main" id="main" tabindex="0" class="fallback" style="margin-bottom: 320px;">
	<router-outlet *ngIf="(!navigationLoading || !isDeepLink) && configReady"></router-outlet>
	<app-loading *ngIf="navigationLoading"></app-loading>
</main>
<footer *ngIf="configReady">
  <div style="margin-top: -320px;" *ngIf="!headerFooterHidden">
    <app-footer></app-footer>
  </div>
</footer>
<app-sidebar>
	<router-outlet name="sidebar"></router-outlet>
</app-sidebar>
<app-modal></app-modal>
<app-multiple-modal></app-multiple-modal>
<app-toast></app-toast>
